import { ClassItem, SubmissionItem, BackupItem, GenreType, VisibilityType } from '../types';
import { generateGenreFallback } from '../utils/thumbnail';

const STORAGE_KEY_CLASSES = 'html_box_classes';
const STORAGE_KEY_SUBMISSIONS = 'html_box_submissions';
const STORAGE_KEY_BACKUPS = 'html_box_backups';
const STORAGE_KEY_ADMIN_TOKEN = 'html_box_admin_token';

// 初期シードデータ (モック/オフライン用)
const DEFAULT_CLASSES: ClassItem[] = [
  {
    id: 'web2026-q1',
    name: 'Webプログラミング演習A (2026春)',
    description: 'HTML5/CSS3/JavaScriptによるWebフロントエンド実践演習',
    themeColor: 'blue',
    passphrase: 'demo',
    createdAt: new Date(Date.now() - 7 * 86400000).toISOString()
  },
  {
    id: 'design2026-q2',
    name: 'UI/UXデザイン特論',
    description: 'インタラクティブなWebUIプロトタイピングとデザインシステム',
    themeColor: 'teal',
    passphrase: 'demo',
    createdAt: new Date(Date.now() - 3 * 86400000).toISOString()
  }
];

const DEFAULT_SUBMISSIONS: SubmissionItem[] = [
  {
    fileName: 'typing_game.html',
    classId: 'web2026-q1',
    title: 'ローマ字タイピング・ラッシュ',
    genre: 'ゲーム',
    author: '向井',
    description: '制限時間60秒でワードを入力してスコアを競う爽快タイピングゲーム。効果音とコンボ演出つき！',
    visibility: 'public',
    submittedAt: new Date(Date.now() - 2 * 86400000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 86400000).toISOString(),
    htmlUrl: 'https://submissions.demo/web2026-q1/typing_game.html',
    thumbnailUrl: generateGenreFallback('ゲーム', 'ローマ字タイピング・ラッシュ'),
    fileSizeBytes: 24500,
    backupCount: 1,
    htmlContent: `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>タイピングゲーム</title>
<style>
body { font-family: sans-serif; background: #0f172a; color: #fff; text-align: center; padding: 50px; }
h1 { color: #60a5fa; }
.card { background: #1e293b; padding: 30px; border-radius: 12px; display: inline-block; margin-top: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.4); }
button { background: #3b82f6; color: white; border: none; padding: 12px 24px; border-radius: 6px; font-size: 16px; cursor: pointer; }
</style></head><body>
<h1>🎮 ローマ字タイピング・ラッシュ</h1>
<div class="card">
<p>準備ができたらスタートボタンを押してください！</p>
<button onclick="alert('ゲームスタート！')">スタート</button>
</div></body></html>`
  },
  {
    fileName: 'calculator.html',
    classId: 'web2026-q1',
    title: 'ネオモルフィズム計算機',
    genre: 'ツール',
    author: '佐藤 健',
    description: '滑らかなソフトシャドウとキーボード入力に対応したモダン電卓ツール。計算履歴機能つき。',
    visibility: 'private',
    submittedAt: new Date(Date.now() - 1 * 86400000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 86400000).toISOString(),
    htmlUrl: 'https://submissions.demo/web2026-q1/calculator.html',
    thumbnailUrl: generateGenreFallback('ツール', 'ネオモルフィズム計算機'),
    fileSizeBytes: 18200,
    backupCount: 0,
    htmlContent: `<!DOCTYPE html><html><head><meta charset="utf-8"><title>計算機</title>
<style>body{font-family:sans-serif;background:#e0e5ec;display:flex;justify-content:center;align-items:center;height:100vh;margin:0;}
.calc{background:#e0e5ec;padding:24px;border-radius:20px;box-shadow:8px 8px 16px #b8b9be,-8px -8px 16px #fff;width:240px;text-align:right;}
.screen{font-size:32px;margin-bottom:16px;color:#333;font-weight:bold;}
</style></head><body><div class="calc"><div class="screen">1,024</div><p style="text-align:center;color:#666;">Ready</p></div></body></html>`
  },
  {
    fileName: 'particles_art.html',
    classId: 'design2026-q2',
    title: '幾何学インタラクティブ・パーティクル',
    genre: 'アート',
    author: '高橋 凛',
    description: 'マウスの軌跡に追従して星屑のように広がるCanvasジェネラティブアート。色相環アニメーション対応。',
    visibility: 'public',
    submittedAt: new Date(Date.now() - 3600000).toISOString(),
    updatedAt: new Date(Date.now() - 3600000).toISOString(),
    htmlUrl: 'https://submissions.demo/design2026-q2/particles_art.html',
    thumbnailUrl: generateGenreFallback('アート', '幾何学パーティクル'),
    fileSizeBytes: 32800,
    backupCount: 0,
    htmlContent: `<!DOCTYPE html><html><head><meta charset="utf-8"><title>パーティクルアート</title>
<style>body{margin:0;overflow:hidden;background:#050505;color:#f472b6;font-family:sans-serif;}
h2{position:absolute;top:20px;left:20px;pointer-events:none;}
</style></head><body><h2>✨ マウスを動かしてみてください</h2>
<canvas id="c"></canvas>
<script>
const c=document.getElementById('c');c.width=window.innerWidth;c.height=window.innerHeight;
const ctx=c.getContext('2d');
window.onmousemove=(e)=>{ctx.fillStyle='rgba(244,114,182,0.8)';ctx.beginPath();ctx.arc(e.clientX,e.clientY,8,0,Math.PI*2);ctx.fill();};
setInterval(()=>{ctx.fillStyle='rgba(5,5,5,0.05)';ctx.fillRect(0,0,c.width,c.height);},50);
</script></body></html>`
  }
];

const DEFAULT_BACKUPS: BackupItem[] = [
  {
    backupId: 'bak_web2026-q1_typing_game_20261001_120000',
    originalFileName: 'typing_game.html',
    classId: 'web2026-q1',
    backupHtmlPath: 'backups/web2026-q1/typing_game_20261001_120000.html',
    backupThumbnailPath: 'backups/web2026-q1/typing_game_20261001_120000.webp',
    title: 'ローマ字タイピング（初版）',
    genre: 'ゲーム',
    author: '向井',
    description: '初版バージョン。制限時間30秒のプロトタイプ。',
    visibility: 'private',
    overwrittenAt: new Date(Date.now() - 2 * 86400000).toISOString(),
    fileSizeBytes: 19400,
    htmlContent: `<!DOCTYPE html><html><body><h1>旧版タイピングゲーム</h1><p>Ver 1.0 (初版)</p></body></html>`
  }
];

class ApiClient {
  private useServerApi: boolean = true;

  constructor() {
    this.initStorage();
  }

  private initStorage() {
    if (!localStorage.getItem(STORAGE_KEY_CLASSES)) {
      localStorage.setItem(STORAGE_KEY_CLASSES, JSON.stringify(DEFAULT_CLASSES));
    }
    if (!localStorage.getItem(STORAGE_KEY_SUBMISSIONS)) {
      localStorage.setItem(STORAGE_KEY_SUBMISSIONS, JSON.stringify(DEFAULT_SUBMISSIONS));
    }
    if (!localStorage.getItem(STORAGE_KEY_BACKUPS)) {
      localStorage.setItem(STORAGE_KEY_BACKUPS, JSON.stringify(DEFAULT_BACKUPS));
    }
  }

  /**
   * 共通 fetch ラッパー (認証ヘッダー付与 & フォールバック判定)
   */
  private async request<T>(
    endpoint: string,
    options: RequestInit = {},
    classIdForPassphrase?: string
  ): Promise<{ data: T | null; isServer: boolean }> {
    if (!this.useServerApi) {
      return { data: null, isServer: false };
    }

    try {
      const headers = new Headers(options.headers || {});
      const adminToken = this.getAdminToken();
      if (adminToken && !headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${adminToken}`);
      }

      if (classIdForPassphrase && !headers.has('X-Class-Passphrase')) {
        const pass = this.getStoredPassphrase(classIdForPassphrase);
        if (pass) {
          headers.set('X-Class-Passphrase', pass);
        }
      }

      const res = await fetch(endpoint, {
        ...options,
        headers,
      });

      if (res.status === 404 && res.headers.get('content-type')?.includes('text/html')) {
        // Vite 開発サーバー等でエンドポイント未提供時のフォールバック
        return { data: null, isServer: false };
      }

      if (!res.ok) {
        const errorJson = await res.json().catch(() => ({}));
        throw new Error((errorJson as any).error || `APIエラー: ${res.status}`);
      }

      const data = await res.json() as T;
      return { data, isServer: true };
    } catch (err: any) {
      // 接続エラーやCORSエラー時はローカルストレージへ安全にフォールバック
      return { data: null, isServer: false };
    }
  }

  // --- 認証系 ---
  public getStoredPassphrase(classId: string): string | null {
    return sessionStorage.getItem(`passphrase_${classId}`);
  }

  public setStoredPassphrase(classId: string, passphrase: string): void {
    sessionStorage.setItem(`passphrase_${classId}`, passphrase);
  }

  public async verifyPassphrase(classId: string, passphrase: string): Promise<boolean> {
    try {
      const res = await fetch('/api/auth/verify-passphrase', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ classId, passphrase }),
      });

      if (res.ok) {
        this.setStoredPassphrase(classId, passphrase);
        return true;
      }
    } catch {
      // サーバー未接続時はローカル比較
    }

    const classes = await this.getClasses();
    const target = classes.find(c => c.id === classId);
    if (!target) return false;
    const valid = (target.passphrase || 'demo') === passphrase.trim();
    if (valid) {
      this.setStoredPassphrase(classId, passphrase);
    }
    return valid;
  }

  public getAdminToken(): string | null {
    return sessionStorage.getItem(STORAGE_KEY_ADMIN_TOKEN);
  }

  public async adminLogin(password: string): Promise<boolean> {
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });

      if (res.ok) {
        const data = await res.json() as { token: string };
        sessionStorage.setItem(STORAGE_KEY_ADMIN_TOKEN, data.token);
        return true;
      }
    } catch {
      // サーバー未接続時
    }

    // 開発・デモ用認証パスワード: "admin2026"
    if (password === 'admin2026' || password === 'admin') {
      const mockJwt = 'mock_jwt_token_' + Date.now();
      sessionStorage.setItem(STORAGE_KEY_ADMIN_TOKEN, mockJwt);
      return true;
    }
    return false;
  }

  public adminLogout(): void {
    sessionStorage.removeItem(STORAGE_KEY_ADMIN_TOKEN);
  }

  // --- 授業（Class）関連 ---
  public async getClasses(): Promise<ClassItem[]> {
    const { data, isServer } = await this.request<ClassItem[]>('/api/classes');
    if (isServer && data) {
      return data;
    }
    const raw = localStorage.getItem(STORAGE_KEY_CLASSES);
    return raw ? JSON.parse(raw) : DEFAULT_CLASSES;
  }

  public async getClass(classId: string): Promise<ClassItem | null> {
    const classes = await this.getClasses();
    return classes.find(c => c.id === classId) || null;
  }

  public async saveClass(classData: ClassItem): Promise<void> {
    // 既存チェック
    const existing = await this.getClass(classData.id);
    if (existing) {
      const { isServer } = await this.request(`/api/classes/${classData.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(classData),
      });
      if (isServer) return;
    } else {
      const { isServer } = await this.request('/api/classes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(classData),
      });
      if (isServer) return;
    }

    const classes = await this.getClasses();
    const idx = classes.findIndex(c => c.id === classData.id);
    if (idx >= 0) {
      classes[idx] = classData;
    } else {
      classes.push(classData);
    }
    localStorage.setItem(STORAGE_KEY_CLASSES, JSON.stringify(classes));
  }

  public async deleteClass(classId: string): Promise<void> {
    const { isServer } = await this.request(`/api/classes/${classId}`, {
      method: 'DELETE',
    });
    if (isServer) return;

    let classes = await this.getClasses();
    classes = classes.filter(c => c.id !== classId);
    localStorage.setItem(STORAGE_KEY_CLASSES, JSON.stringify(classes));
  }

  // --- 提出物（Submission）関連 ---
  public async checkConflict(classId: string, fileName: string): Promise<boolean> {
    const { data, isServer } = await this.request<{ exists: boolean }>(
      `/api/check-conflict?classId=${encodeURIComponent(classId)}&file=${encodeURIComponent(fileName)}`,
      {},
      classId
    );
    if (isServer && data) {
      return data.exists;
    }

    const submissions = await this.getSubmissions(classId);
    return submissions.some(s => s.fileName.toLowerCase() === fileName.toLowerCase());
  }

  public async getSubmissions(classId?: string, onlyPublic: boolean = false): Promise<SubmissionItem[]> {
    let endpoint = '/api/submissions';
    const params = new URLSearchParams();
    if (classId) params.set('classId', classId);
    if (onlyPublic) params.set('visibility', 'public');
    if (params.toString()) {
      endpoint += `?${params.toString()}`;
    }

    const { data, isServer } = await this.request<SubmissionItem[]>(endpoint, {}, classId);
    if (isServer && data) {
      return data;
    }

    const raw = localStorage.getItem(STORAGE_KEY_SUBMISSIONS);
    let list: SubmissionItem[] = raw ? JSON.parse(raw) : [];

    if (classId) {
      list = list.filter(s => s.classId === classId);
    }
    if (onlyPublic) {
      list = list.filter(s => s.visibility === 'public');
    }

    return list.sort((a, b) => new Date(b.submittedAt).getTime() - new Date(a.submittedAt).getTime());
  }

  public async getSubmission(classId: string, fileName: string): Promise<SubmissionItem | null> {
    const { data, isServer } = await this.request<SubmissionItem>(
      `/api/submissions/${encodeURIComponent(classId)}/${encodeURIComponent(fileName)}`
    );
    if (isServer && data) {
      return data;
    }

    const list = await this.getSubmissions(classId);
    return list.find(s => s.fileName === fileName) || null;
  }

  public async uploadSubmission(params: {
    classId: string;
    fileName: string;
    fileContent: string;
    title: string;
    genre: GenreType;
    author: string;
    description: string;
    visibility: VisibilityType;
    thumbnailUrl: string;
    fileSizeBytes: number;
    passphrase?: string;
  }): Promise<{ success: boolean; isOverwritten: boolean }> {
    const { data, isServer } = await this.request<{ success: boolean; isOverwritten: boolean }>(
      '/api/upload',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          classId: params.classId,
          fileName: params.fileName,
          fileContent: params.fileContent,
          title: params.title,
          genre: params.genre,
          author: params.author,
          description: params.description,
          visibility: params.visibility,
          thumbnailDataUrl: params.thumbnailUrl,
          fileSizeBytes: params.fileSizeBytes,
        }),
      },
      params.classId
    );

    if (isServer && data) {
      return data;
    }

    // ローカルストレージ処理フォールバック
    const rawSubs = localStorage.getItem(STORAGE_KEY_SUBMISSIONS);
    let list: SubmissionItem[] = rawSubs ? JSON.parse(rawSubs) : [];

    const existingIdx = list.findIndex(s => s.classId === params.classId && s.fileName === params.fileName);
    let isOverwritten = false;

    if (existingIdx >= 0) {
      isOverwritten = true;
      const oldItem = list[existingIdx];
      await this.createBackup(oldItem);
    }

    const newItem: SubmissionItem = {
      fileName: params.fileName,
      classId: params.classId,
      title: params.title,
      genre: params.genre,
      author: params.author || '匿名',
      description: params.description,
      visibility: params.visibility,
      submittedAt: existingIdx >= 0 ? list[existingIdx].submittedAt : new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      htmlUrl: `https://submissions.demo/${params.classId}/${params.fileName}`,
      thumbnailUrl: params.thumbnailUrl,
      fileSizeBytes: params.fileSizeBytes,
      backupCount: (existingIdx >= 0 ? list[existingIdx].backupCount + 1 : 0),
      htmlContent: params.fileContent
    };

    if (existingIdx >= 0) {
      list[existingIdx] = newItem;
    } else {
      list.unshift(newItem);
    }

    localStorage.setItem(STORAGE_KEY_SUBMISSIONS, JSON.stringify(list));
    return { success: true, isOverwritten };
  }

  public async updateSubmission(
    classId: string,
    fileName: string,
    updates: Partial<SubmissionItem> & { htmlContent?: string }
  ): Promise<void> {
    const { isServer } = await this.request(
      `/api/submissions/${encodeURIComponent(classId)}/${encodeURIComponent(fileName)}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates),
      }
    );
    if (isServer) return;

    const rawSubs = localStorage.getItem(STORAGE_KEY_SUBMISSIONS);
    let list: SubmissionItem[] = rawSubs ? JSON.parse(rawSubs) : [];
    const idx = list.findIndex(s => s.classId === classId && s.fileName === fileName);
    if (idx >= 0) {
      list[idx] = {
        ...list[idx],
        ...updates,
        updatedAt: new Date().toISOString()
      };
      localStorage.setItem(STORAGE_KEY_SUBMISSIONS, JSON.stringify(list));
    }
  }

  public async deleteSubmission(classId: string, fileName: string): Promise<void> {
    const { isServer } = await this.request(
      `/api/submissions/${encodeURIComponent(classId)}/${encodeURIComponent(fileName)}`,
      {
        method: 'DELETE',
      }
    );
    if (isServer) return;

    const rawSubs = localStorage.getItem(STORAGE_KEY_SUBMISSIONS);
    let list: SubmissionItem[] = rawSubs ? JSON.parse(rawSubs) : [];
    list = list.filter(s => !(s.classId === classId && s.fileName === fileName));
    localStorage.setItem(STORAGE_KEY_SUBMISSIONS, JSON.stringify(list));
  }

  public async getRawHtml(classId: string, fileName: string): Promise<string> {
    const adminToken = this.getAdminToken();
    try {
      const res = await fetch(`/api/submissions/${encodeURIComponent(classId)}/${encodeURIComponent(fileName)}/raw`, {
        headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
      });
      if (res.ok) {
        return await res.text();
      }
    } catch {}

    const sub = await this.getSubmission(classId, fileName);
    return sub?.htmlContent || '<!-- HTMLコンテンツがありません -->';
  }

  // --- バックアップ＆リストア関連 ---
  private async createBackup(oldItem: SubmissionItem): Promise<void> {
    const rawBackups = localStorage.getItem(STORAGE_KEY_BACKUPS);
    let backups: BackupItem[] = rawBackups ? JSON.parse(rawBackups) : [];

    const now = new Date();
    const ts = now.toISOString().replace(/[-:T.]/g, '').slice(0, 14);
    const backupId = `bak_${oldItem.classId}_${oldItem.fileName.replace('.html', '')}_${ts}`;

    const newBackup: BackupItem = {
      backupId,
      originalFileName: oldItem.fileName,
      classId: oldItem.classId,
      backupHtmlPath: `backups/${oldItem.classId}/${oldItem.fileName.replace('.html', '')}_${ts}.html`,
      backupThumbnailPath: `backups/${oldItem.classId}/${oldItem.fileName.replace('.html', '')}_${ts}.webp`,
      title: oldItem.title,
      genre: oldItem.genre,
      author: oldItem.author,
      description: oldItem.description,
      visibility: oldItem.visibility,
      overwrittenAt: now.toISOString(),
      fileSizeBytes: oldItem.fileSizeBytes,
      htmlContent: oldItem.htmlContent
    };

    backups.unshift(newBackup);

    const sameFileBackups = backups.filter(b => b.classId === oldItem.classId && b.originalFileName === oldItem.fileName);
    if (sameFileBackups.length > 5) {
      const toRemove = sameFileBackups.slice(5);
      const removeIds = new Set(toRemove.map(b => b.backupId));
      backups = backups.filter(b => !removeIds.has(b.backupId));
    }

    localStorage.setItem(STORAGE_KEY_BACKUPS, JSON.stringify(backups));
  }

  public async getBackups(classId?: string, fileName?: string): Promise<BackupItem[]> {
    let endpoint = '/api/backups';
    const params = new URLSearchParams();
    if (classId) params.set('classId', classId);
    if (fileName) params.set('file', fileName);
    if (params.toString()) {
      endpoint += `?${params.toString()}`;
    }

    const { data, isServer } = await this.request<BackupItem[]>(endpoint);
    if (isServer && data) {
      return data;
    }

    const rawBackups = localStorage.getItem(STORAGE_KEY_BACKUPS);
    let backups: BackupItem[] = rawBackups ? JSON.parse(rawBackups) : [];
    if (classId) {
      backups = backups.filter(b => b.classId === classId);
    }
    if (fileName) {
      backups = backups.filter(b => b.originalFileName === fileName);
    }
    return backups;
  }

  public async restoreBackup(backupId: string): Promise<void> {
    const { isServer } = await this.request(`/api/backups/${encodeURIComponent(backupId)}/restore`, {
      method: 'POST',
    });
    if (isServer) return;

    const rawBackups = localStorage.getItem(STORAGE_KEY_BACKUPS);
    let backups: BackupItem[] = rawBackups ? JSON.parse(rawBackups) : [];
    const backup = backups.find(b => b.backupId === backupId);
    if (!backup) throw new Error('Backup not found');

    const current = await this.getSubmission(backup.classId, backup.originalFileName);
    if (current) {
      await this.createBackup(current);
    }

    const restoredItem: SubmissionItem = {
      fileName: backup.originalFileName,
      classId: backup.classId,
      title: backup.title,
      genre: backup.genre,
      author: backup.author,
      description: backup.description,
      visibility: backup.visibility,
      submittedAt: current ? current.submittedAt : backup.overwrittenAt,
      updatedAt: new Date().toISOString(),
      htmlUrl: `https://submissions.demo/${backup.classId}/${backup.originalFileName}`,
      thumbnailUrl: generateGenreFallback(backup.genre, backup.title),
      fileSizeBytes: backup.fileSizeBytes,
      backupCount: 1,
      htmlContent: backup.htmlContent
    };

    const rawSubs = localStorage.getItem(STORAGE_KEY_SUBMISSIONS);
    let list: SubmissionItem[] = rawSubs ? JSON.parse(rawSubs) : [];
    const idx = list.findIndex(s => s.classId === backup.classId && s.fileName === backup.originalFileName);
    if (idx >= 0) {
      list[idx] = restoredItem;
    } else {
      list.unshift(restoredItem);
    }
    localStorage.setItem(STORAGE_KEY_SUBMISSIONS, JSON.stringify(list));
  }

  public async publishBackupAs(backupId: string, newFileName: string): Promise<void> {
    const { isServer } = await this.request(`/api/backups/${encodeURIComponent(backupId)}/publish-as`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ newFileName }),
    });
    if (isServer) return;

    const rawBackups = localStorage.getItem(STORAGE_KEY_BACKUPS);
    let backups: BackupItem[] = rawBackups ? JSON.parse(rawBackups) : [];
    const backup = backups.find(b => b.backupId === backupId);
    if (!backup) throw new Error('Backup not found');

    const newItem: SubmissionItem = {
      fileName: newFileName,
      classId: backup.classId,
      title: `${backup.title} (復旧版)`,
      genre: backup.genre,
      author: backup.author,
      description: backup.description,
      visibility: backup.visibility,
      submittedAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      htmlUrl: `https://submissions.demo/${backup.classId}/${newFileName}`,
      thumbnailUrl: generateGenreFallback(backup.genre, backup.title),
      fileSizeBytes: backup.fileSizeBytes,
      backupCount: 0,
      htmlContent: backup.htmlContent
    };

    const rawSubs = localStorage.getItem(STORAGE_KEY_SUBMISSIONS);
    let list: SubmissionItem[] = rawSubs ? JSON.parse(rawSubs) : [];
    list.unshift(newItem);
    localStorage.setItem(STORAGE_KEY_SUBMISSIONS, JSON.stringify(list));
  }

  public async deleteBackup(backupId: string): Promise<void> {
    const { isServer } = await this.request(`/api/backups/${encodeURIComponent(backupId)}`, {
      method: 'DELETE',
    });
    if (isServer) return;

    const rawBackups = localStorage.getItem(STORAGE_KEY_BACKUPS);
    let backups: BackupItem[] = rawBackups ? JSON.parse(rawBackups) : [];
    backups = backups.filter(b => b.backupId !== backupId);
    localStorage.setItem(STORAGE_KEY_BACKUPS, JSON.stringify(backups));
  }
}

export const api = new ApiClient();
